<!-- 新增编辑框 -->
<template>
  <a-modal
    :title="title"
    width="1000px"
    :visible="visible"
    @cancel="onClose"
    v-if="visible"
    class="notice-edit"
  >
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :colon="false"
      class="drawer-view"
    >
      <a-form-model-item label="通知内容" prop="noticeContent">
        <InputText
          v-model="ruleForm.noticeContent"
          allowClear
          type="textarea"
          :maxLength="10000"
          :disabled="isDisabled"
        />
      </a-form-model-item>
      <a-form-model-item label="附件">
        <a-upload
          :show-upload-list="false"
          :beforeUpload="beforeUpload"
          :customRequest="customRequest"
          @change="handleChange"
          multiple
        >
          <a-button class="upload" :disabled="isDisabled">
            <a-icon :type="uploadLoading ? 'loading' : 'upload'" /> 上传附件
          </a-button>
        </a-upload>

        <div
          v-for="(item, index) in fileList"
          :key="index"
          class="file-list-style"
        >
          <div class="left" @click="downFile(item)">
            <a-icon type="paper-clip" class="icon" /><span class="label">{{
              item.name
            }}</span>
          </div>
          <div class="right" v-if="!isDisabled" @click="deleteItem(index)">
            <a-icon type="delete" />
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="发布状态" prop="publishStatus">
        <SelectModule
          v-model="ruleForm.publishStatus"
          apiType="getDictDataByCode"
          :apiParams="{ dictCode: 'publish_status' }"
          :showAll="true"
          :disabled="isDisabled"
        />
      </a-form-model-item>
      <a-form-model-item
        label="可查看组织机构"
        prop="noticeOrgList"
        class="tree"
      >
        <a-tree
          v-if="treeData.length > 0"
          ref="tree"
          checkable
          default-expand-all
          v-model="ruleForm.noticeOrgList"
          :tree-data="treeData"
          @check="onCheck"
          :checkStrictly="true"
          class="org_tree"
          :disabled="isDisabled"
        />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="onClose">取消</a-button>
      <a-button type="primary" v-if="modalType != '3'" @click.stop="onSave"
        >确定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组建
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import API from "@/api/logManage.js"; // 请求接口
export default {
  components: {
    InputText,
    SelectModule,
  },
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
    // 操作项类型
    modalType: {
      type: String,
      required: true,
      default: "",
    },
  },
  computed: {
    title() {
      let str = "";
      if (this.modalType == "2") {
        str = "编辑";
      } else if (this.modalType == "3") {
        str = "查看";
      } else {
        str = "新增";
      }
      return str;
    },
    isDisabled() {
      return this.modalType === "3";
    },
  },
  data() {
    return {
      ruleForm: {
        id: "", // 主键ID
        noticeContent: "",
        publishStatus: "0",
        noticeOrgList: [], // 可查看组织机构
      },
      uploadLoading: false,
      fileList: [], // 附件集合
      treeData: [], // 权限树数据
      rules: {
        noticeContent: [
          { required: true, message: "请输入通知内容!", trigger: "change" },
        ],
        publishStatus: [
          { required: true, message: "请选择发布状态!", trigger: "change" },
        ],
        noticeOrgList: [
          {
            required: true,
            type: "array",
            message: "请选择组织机构!",
            trigger: "change",
          },
        ],
      },
      funcAuthorities: [],
      funcAuthoritiesArr: [],
      visible: false,
      treeChildrenData: [], // 最深层子节点的合计
      isClick: false,
      checkArr: [],
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 获取详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.ruleForm.id,
          },
        },
      };
      API.getDrugMessageNotice(params, (callback) => {
        let arr = [];
        if (callback.status == "S" && callback.data) {
          let backData = callback.data;
          this.ruleForm.noticeContent = backData.noticeContent || "";
          this.ruleForm.publishPerson = backData.publishPerson || "";
          this.ruleForm.publishStatus = backData.publishStatus || "0";
          let roleMenus = backData.noticeOrgList || [];
          roleMenus &&
            roleMenus.map((item) => {
              arr.push({
                orgId: item.orgId,
                orgName: item.orgName,
              });
            });
          this.funcAuthoritiesArr = arr;
          this.getTreeData(arr);

          let attachInfoList = [];
          backData.attachInfoList &&
            backData.attachInfoList.map((item) => {
              let obj = {};
              obj.url = item.attachUrl;
              obj.name = item.attachFileName;
              obj.type = item.attachFileType;
              attachInfoList.push(obj);
            });
          this.fileList = attachInfoList || [];
        }
      });
    },

    // 获取机构树
    getTreeData(checked) {
      this.funcAuthorities = [];
      API.loadOrgByParentId(
        {
          data: {
            params: {},
          },
        },
        (callback) => {
          if (callback.status == "S" && callback.data) {
            if (Array.isArray(callback.data) && callback.data.length > 0) {
              let data = callback.data;
              // let data = [
              //   {
              //     id: "root",
              //     name: "国家局",
              //     children: [
              //       {
              //         id: "123",
              //         name: "国家局1",
              //         children: [
              //           {
              //             id: "123456",
              //             name: "国家局11",
              //           },
              //         ],
              //       },
              //       {
              //         id: '1HF40PDBEETH7K00VVPO6NMIH0MPC8P1',
              //         name: '山东省药品监督管理局'
              //       }
              //     ],
              //   },
              // ];
              this.treeData = this.getChildren(data);
              if (checked) {
                let test = this.getFilter(data); // 得到子元素
                let uniqueChild = this.uniqueTree(checked, test);
                this.funcAuthorities = uniqueChild;
                this.ruleForm.noticeOrgList = uniqueChild || [];
              }
            }
          }
        }
      );
    },
    // 递归获取树形结构的子集
    getChildren(data) {
      let itemArr = [];
      data.forEach((item) => {
        let config = {
          title: item.name,
          key: item.id,
        };
        if (item.children) {
          config.children = this.getChildren(item.children);
        }
        itemArr.push(config);
      });

      return itemArr;
    },
    // 循环遍历出最深层子节点，存放在一个数组中
    getFilter(data) {
      data &&
        data.map((item) => {
          this.treeChildrenData.push(item.id);
          if (item.children && item.children.length > 0) {
            this.getFilter(item.children);
          }
          // else {
          //   this.treeChildrenData.push(item.id);
          // }
          return null;
        });
      return this.treeChildrenData;
    },
    uniqueTree(uniqueArr, Arr) {
      let uniqueChild = [];
      for (var i in Arr) {
        for (var k in uniqueArr) {
          if (uniqueArr[k].orgId == Arr[i]) {
            uniqueChild.push(uniqueArr[k].orgId);
          }
        }
      }
      return uniqueChild;
    },
    getCheckFilter(treeData, checkedKeys) {
      let config = {};
      if (treeData && treeData.length > 0) {
        treeData.map((item) => {
          if (checkedKeys.indexOf(item.key) != -1) {
            config = {
              orgId: item.key,
              orgName: item.title,
            };
            this.checkArr.push(config);
          }
          if (item.children && item.children.length > 0) {
            this.getCheckFilter(item.children, checkedKeys);
          }
        });
      }

      return this.checkArr;
    },
    // 选中某节点
    onCheck(checkedKeys, info, data) {
      this.checkArr = [];
      this.ruleForm.noticeOrgList = checkedKeys.checked; // 当前选中节点
      let arr = this.getCheckFilter(this.treeData, checkedKeys.checked);
      this.funcAuthorities = arr; // 包含父选中节点
      this.$refs.ruleForm.validateField("noticeOrgList");
      this.isClick = true;
    },
    // onCheck(checkedKeys) {

    // },
    // 保存
    onSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      let attachInfoList = [];
      this.fileList &&
        this.fileList.map((item) => {
          let obj = {};
          obj.attachUrl = item.url;
          obj.attachFileName = item.name;
          obj.attachFileType = item.type;
          attachInfoList.push(obj);
        });

      this.loading = true;
      let params = {
        data: {
          params: {
            id: this.modalData.id || "",
            noticeContent: this.ruleForm.noticeContent,
            publishStatus: this.ruleForm.publishStatus,
            noticeOrgList: this.isClick
              ? this.funcAuthorities
              : this.funcAuthoritiesArr,
            attachInfoList: attachInfoList,
          },
        },
      };
      
      API.saveDrugMessageNotice(params, (callback) => {
        this.loading = false;
        if (callback.status == "S") {
          let str = "";
          if (this.modalType == "2") {
            str = "编辑";
          } else if (this.modalType == "3") {
            str = "查看";
          } else {
            str = "新增";
          }
          this.$message.destroy();
          this.$message.success(`${str}成功`);
          this.$emit("handleFlag", false, {}, "", "ok");
        }
      });
    },
    // 校验文件大小
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20; // 文件大小不超过20MB
      if (!isLt2M) {
        this.$message.error("不允许上传超过20MB的文件，请重新上传!");
        return false; // 不允许上传超过20MB的文件，并阻止默认上传行为。
      }
      return true; // 允许上传小于20MB的文件。
    },
    // 上传
    customRequest(options) {
      let params = new FormData();
      params.append("file", options.file);
      this.uploadLoading = true;

      API.uploadFileEnCode(params, (callback) => {
        this.uploadLoading = false;
        if (callback.status == "S" && callback.data) {
          this.fileList.push({
            name: options.file.name,
            type: options.file.type,
            url: callback.data,
          });
        }
      });
    },
    // 下载
    downFile(file) {
      let params = {
        data: {
          params: {
            downLoadUrl: file.url || "",
          },
        },
      };
      API.downLoadFileByUrl(params, (callback) => {});
    },
    // 删除
    deleteItem(index) {
      this.fileList.splice(index, 1);
    },
    // 上传
    handleChange(obj) {
      console.log("obj", obj);
    },
  },
  watch: {
    // 模态框开关
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.ruleForm.id = this.modalData.id || "";
        if (JSON.stringify(this.modalData) != "{}") {
          // 编辑
          this.getDetail();
        } else {
          this.getTreeData();
        }
      } else {
        this.isClick = false;
        this.treeData = [];
        this.funcAuthorities = [];
        this.funcAuthoritiesArr = [];
        this.treeChildrenData = [];
        this.checkArr = [];
        this.ruleForm.id = "";
        this.ruleForm = {
          id: "", // 主键ID
          noticeContent: "",
          publishStatus: "0",
          noticeOrgList: [], // 可查看组织机构
        };
        this.fileList = []; // 清空附件
        this.$refs.ruleForm.resetFields();
      }
    },
  },
};
</script>

<style scoped lang="less">
.notice-edit {
  :deep .drawer-view {
    .ant-form-item-control-wrapper .ant-form-item-control {
      height: auto;
    }
  }
  :deep .tree {
    margin-bottom: 0;
    // max-height: 300px;
    // overflow-y: auto;
    .ant-form-item-control {
      height: auto;
    }
    .ant-tree-node-content-wrapper-normal {
      display: inline-block;
      width: 580px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .org_tree {
      max-height: 300px;
      overflow-y: auto;
    }
  }

  .file-list-style {
    padding: 0px 8px;
    cursor: pointer;
    border-radius: 2px;
    display: flex;

    .left {
      flex: 1;
      color: #00000073;

      .label {
        padding-left: 10px;
      }
    }
    .right {
      width: 16px;
      color: #00000073;
      display: none;
    }
  }
  .upload {
    margin-bottom: 10px;
  }
  .file-list-style:hover {
    background-color: #f5f5f5;
    .left {
      .label {
        color: #0553a5;
      }
    }
    .right {
      display: inline-block;
      color: #ff4d4f;
    }
  }
}
</style>
